export default "__VITE_ASSET__32a96716__"